/**
 * Money Makeover Consultants — Shopify Theme JS
 * Vanilla JS — No frameworks
 */

document.addEventListener('DOMContentLoaded', () => {

  /* ─── 1. STICKY NAV — scroll class ────────────────────────── */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 50);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ─── 2. MOBILE MENU toggle ─────────────────────────────── */
  const hamburger = document.getElementById('nav-hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ─── 3. SMOOTH SCROLL for anchor links ─────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
        if (mobileMenu) mobileMenu.classList.remove('open');
        if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* ─── 4. SCROLL REVEAL — IntersectionObserver ────────────── */
  const revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length) {
    const revealObs = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.revealDelay || 0;
          setTimeout(() => {
            entry.target.classList.add('is-visible');
          }, delay);
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(el => revealObs.observe(el));
  }

  /* ─── 5. SCORE BAR ANIMATION ─────────────────────────────── */
  const scoreBars = document.querySelectorAll('.score-bar-fill');
  if (scoreBars.length) {
    const barObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          barObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    scoreBars.forEach(bar => barObs.observe(bar));
  }

  /* ─── 6. FAQ ACCORDION (standalone FAQ page) ─────────────── */
  document.querySelectorAll('.faq-standalone-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      // Close all
      document.querySelectorAll('.faq-standalone-btn').forEach(b => {
        b.setAttribute('aria-expanded', 'false');
        b.closest('.faq-standalone-item').querySelector('.faq-standalone-answer-wrap').classList.remove('open');
      });
      // Open clicked if it was closed
      if (!expanded) {
        btn.setAttribute('aria-expanded', 'true');
        btn.closest('.faq-standalone-item').querySelector('.faq-standalone-answer-wrap').classList.add('open');
      }
    });
  });

  /* ─── 7. MARQUEE pause-on-hover ─────────────────────────── */
  // Handled via CSS group-hover equiv: listening on parent
  document.querySelectorAll('.results-marquee-wrap, .reviews-marquee-outer').forEach(wrap => {
    wrap.addEventListener('mouseenter', () => {
      wrap.querySelectorAll('.results-track, .reviews-track').forEach(t => {
        t.style.animationPlayState = 'paused';
      });
    });
    wrap.addEventListener('mouseleave', () => {
      wrap.querySelectorAll('.results-track, .reviews-track').forEach(t => {
        t.style.animationPlayState = 'running';
      });
    });
  });

  /* ─── 8. TRUST MARQUEE dupe ─────────────────────────────── */
  // Already duplicated in liquid; nothing extra needed

  console.log('[MMC Theme] Initialized ✓');
});
